import { render } from "./Unauthorized.vue?vue&type=template&id=720045c2"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"
script.render = render

export default script